import { connect } from 'react-redux'
import { getArchivedPostDischargesList } from '../actions/actions-archived-postdischarges'
import { getProgramsAssignedToLoginList } from '../actions/actions-programs'
import ArchivedPostDischarges from '../views/ArchivedPostDischarges/archived-postdischarges'
const mapStateToProps = (state, ownProps) => {
  return {
    parentProps: ownProps,
    archivedpostdischarges: state.archivedpostdischargesR.dataList,
    programsAssigned: state.programsR.programsassignedtologin
  }
}
const mapDispatchToProps = dispatch => {
  return {
    getArchivedPostDischarges: loginID => {
      dispatch(getArchivedPostDischargesList(loginID))
    },
    getProgramsAssignedToLoginList: id => {
      dispatch(getProgramsAssignedToLoginList(id))
    }
  }
}
const ArchivedPostDischargeListContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(ArchivedPostDischarges)
export default ArchivedPostDischargeListContainer
